import merge from 'lodash/merge';
import userPolicies from './user';
import esgKpiPolicy from './esgKpiPolicy';

export default merge(userPolicies, esgKpiPolicy);
